import React from 'react';
import ResponseTypo from './ResponseTypo';
import { HalfLayout } from './HalfLayout';
import { StoryPlayer } from './StoryPlayer';
import '../../../styles/story/story.css';
import {
  SITE_CONFIG_KEY,
  StoryMissionText,
} from '../../../constants/types/site-config-type';
import { useSiteConfig } from '../../../hooks/useSiteConfig';
import { parseSiteConfigObject } from '../../../api/utils/api/siteConfigApi';

// API 조회 실패 시 사용할 기본값
const MISSION_VIDEO_FALLBACK =
  'https://youtu.be/TkvW6vOr_fU?si=nhIL0GG0C246lsgK';
const MISSION_TEXT_FALLBACK: StoryMissionText = {
  title: 'Speak n Spread',
  subtitle: '영어로 말씀을 암송한다는 것,\n복음을 전한다는 것!',
  description:
    '우리가 ‘영어’를 배우는 진짜 이유\n하나님이 우리에게 주신 지상명령을 실현하기 위해\n어디서든 복음을 전할 수 있도록 필수 언어인 영어를 배웁니다.',
};

const SITE_CONFIG_KEYS = [
  SITE_CONFIG_KEY.JEBS_STORY_MISSION_TEXT,
  SITE_CONFIG_KEY.JEBS_STORY_MISSION_VIDEO,
];

/** 젭스 스토리 - 사명 소개 영역 */
export const StoryMission = () => {
  const { configs, loading } = useSiteConfig(SITE_CONFIG_KEYS);
  const videoUrl =
    configs[SITE_CONFIG_KEY.JEBS_STORY_MISSION_VIDEO] || MISSION_VIDEO_FALLBACK;
  // 어드민에서 일부 필드를 빠뜨려도 해당 필드만 기본값으로 채운다
  const text = {
    ...MISSION_TEXT_FALLBACK,
    ...parseSiteConfigObject<Partial<StoryMissionText>>(
      configs[SITE_CONFIG_KEY.JEBS_STORY_MISSION_TEXT],
    ),
  };

  return (
    <section className="bg-gradient-to-b from-spotLilac/[0.1] to-white p-5 lg:py-14">
      <div className="lg:m-auto lg:max-w-[1024px]">
        <HalfLayout
          className="lg:m-auto lg:max-w-[1024px]"
          left={
            <>
              <ResponseTypo
                variant_lg="h1"
                variant_sm="h4"
                className="gradient-purple mt-6 whitespace-pre-line font-bold"
              >
                {text.title}
              </ResponseTypo>

              <ResponseTypo
                variant_lg="h5"
                variant_sm="h5"
                className="mt-4 whitespace-pre-line font-bold text-spotViolet"
              >
                {text.subtitle}
              </ResponseTypo>

              <ResponseTypo
                variant_lg="small"
                variant_sm="small"
                className="mt-4 whitespace-pre-line"
              >
                {text.description}
              </ResponseTypo>
            </>
          }
          right={
            // 설정 조회 전에 폴백 URL로 StoryPlayer 컴포넌트를 띄우면 URL이 바뀌며 다시 로드되므로 조회 후 넘긴다
            <StoryPlayer url={loading ? undefined : videoUrl} />
          }
        />
      </div>
    </section>
  );
};
